import React, {useState} from 'react'
import Tr from 'translations/Translations';
import Dialog from 'components/Dialog';
import GridBlock from 'components/GridBlock';
import Form from 'components/Form';
import * as Yup from 'yup';
import useId from 'hooks/useId';
import {connect} from 'react-redux'
import DoubleButton from "components/popup/components/DoubleButton";
import DateTimePicker from "components/DateTimePicker";
import VS from "constants/ValidationShema";
import Loading from "components/Loading";
import TypographyWithIcon from "components/TypographyWithIcon";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import FinishDemandService from "services/FinishDemandService";
import isResponseValid from "libs/isResponseValid";
import moment from "libs/moment";


function UnpublishNoticePopup(
    {
        demandId,
        onSuccess,
        onCancel,
        initialDate,
        formSubmit
    }) {


    const formId = useId();
    const handleSubmit = () => formSubmit[formId]();
    const [working, setWorking] = useState(false);
    const [error, setError] = useState(null);

    const onSubmit = (values) => {
        setError(null);
        setWorking(true);
        const resp = FinishDemandService.withdrawalNoticeDate(demandId, values);
        if(isResponseValid(resp, setError)) {
            onSuccess();
        }
    }

    return (
        <Dialog
            title={Tr(!initialDate ? 'demand_finish_withdraw_notice' : 'demand_finish_withdraw_notice_update')}
            open={true}
            maxWidth={'xs'}
            dialogActions={<DoubleButton
                justify='flex-end'
                labelFirst={Tr('cancel')}
                labelSecond={Tr('confirm')}
                onClickFirst={onCancel}
                onClickSecond={handleSubmit}
                disabledFirst={working}
                disabledSecond={working}
            />}
        >

            <Form
                initialValues={{
                    unpublishDate: initialDate ? moment(initialDate) : null
                }}
                validationSchema={Yup.object().shape({
                    unpublishDate: VS.dateTimeMinNoRq(new Date(), Tr('v_data_can_not_be_past'))
                })}
                onSubmit={onSubmit}
                id={formId}
            >
                {(formikProps) => (
                    <GridBlock column>
                        {working && <Loading/>}
                        {!!error && <TypographyWithIcon Icon={ErrorOutlineIcon} color='error'>{error}</TypographyWithIcon>}
                        <DateTimePicker
                            formikProps={formikProps}
                            id='unpublishDate'
                            label={Tr('demand_finish_withdrawal_notice_label')}
                            disabled={working}
                            minDate={new Date()}
                        />
                    </GridBlock>
                )}
            </Form>
        </Dialog>
    )
}

export default connect((state) => ({
    formSubmit: state.form,
}), {})(UnpublishNoticePopup);